import React, { useEffect } from 'react';
import { useGlobalAlerts } from '../components/alert/AlertProvider';
import { setGlobalAlertService } from '../../services/globalAlertService';

/**
 * Service component that bridges the global alert service with React context
 * This component should be placed inside the AlertProvider to connect the service
 */
const GlobalAlertService: React.FC = () => {
    const alertMethods = useGlobalAlerts();

    useEffect(() => {
        // Set up the global alert service for use outside React components
        setGlobalAlertService({
            showSuccess: (message: string, options?: { autoDismissTime?: number }) => {
                alertMethods.showSuccess(message, {
                    autoDismissTime: options?.autoDismissTime !== undefined ? options.autoDismissTime : 3000,
                });
            },
            showError: (message: string, options?: { autoDismissTime?: number }) => {
                alertMethods.showError(message, {
                    autoDismissTime: options?.autoDismissTime !== undefined ? options.autoDismissTime : 5000,
                });
            },
            showWarning: (message: string, options?: { autoDismissTime?: number }) => {
                alertMethods.showWarning(message, {
                    autoDismissTime: options?.autoDismissTime !== undefined ? options.autoDismissTime : 8000,
                });
            },
            showInfo: (message: string, options?: { autoDismissTime?: number }) => {
                alertMethods.showInfo(message, {
                    autoDismissTime: options?.autoDismissTime !== undefined ? options.autoDismissTime : 5000,
                });
            },
        });

        // Cleanup on unmount
        return () => {
            setGlobalAlertService({
                showSuccess: () => console.log('Global alert service not available'),
                showError: () => console.error('Global alert service not available'),
                showWarning: () => console.warn('Global alert service not available'),
                showInfo: () => console.info('Global alert service not available'),
            });
        };
    }, [alertMethods]);

    return null; // This component doesn't render anything
};

export default GlobalAlertService;
